import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class BasicServiceBusController {
    constructor($sce) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
    }
    $onDestroy() { return this.bus.dispose(); }
};
